import { render } from "./premiumCourseInfo.vue?vue&type=template&id=1e2dcd37&scoped=true"
import script from "./premiumCourseInfo.vue?vue&type=script&lang=js"
export * from "./premiumCourseInfo.vue?vue&type=script&lang=js"

import "./premiumCourseInfo.vue?vue&type=style&index=0&id=1e2dcd37&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e2dcd37"]])

export default __exports__